import * as React from "react"

import { Action } from "@tenforce/toolbox-button-push-react"

import { Symbols } from "@tenforce/toolbox-fontmap"
import { Labels } from "../../../util/Translations"
import { ITenForceWindow } from "../../../global"

declare let window: ITenForceWindow

export const CreateNewItemCard = (): JSX.Element => {
    const { CreateNewItem } = Labels

    return (
        <article className="tw-w-full md:tw-w-1/2 lg:tw-w-1/4 tw-p-2">
            <Action
                extraClasses="NewUI-card tw-w-full theme-note"
                onClick={(): void =>
                    window.oldUICardView.datalist.addNewItem({ ItemId: -1 })
                }
                title={CreateNewItem}
                data-ft-cni
            >
                <div className="NewUI-card__block tw-w-full">
                    {Symbols.Create}&nbsp;{CreateNewItem}
                </div>
            </Action>
        </article>
    )
}

export default CreateNewItemCard
